module.exports = __webpack_public_path__ + "img/visa-cut.5a1a1025.jpg";